<div class="card stickyCard">
  <div class="card-header-white header-underline d-flex justify-content-between">
    <h6 class="white-header-text">{{location.name}} ({{location.id}})</h6>
    <span class="float-right cursorPointer icon-container" (click)="closeLocationCard()" >
      <span
        class="fa-light fa-xmark white-header-xmark-icon">
      </span>
    </span>
  </div>
  <div class="card-body-white">
    @if (location) {
      <div class="row">
        @if (!deleteConfirmation) {
          <div class="col-lg-12">
            <div class="mb-2">
              <ul class="list-inline">
                <li class="list-inline-item">
                  <span class="editPageTab" [ngClass]="{'editPageTab-active' : activeTab === 1}"
                  (click)="activeTab = 1">{{'INFORMATION' |translate}}</span>
                </li>
                <li class="list-inline-item">
                  <span class="editPageTab" [ngClass]="{'editPageTab-active' : activeTab === 3}"
                  (click)="activeTab = 3">{{'ACCESS_RIGHTS' |translate}}</span>
                </li>
                <li class="list-inline-item">
                  @if (showIfFeatureEnabled('EveronMobileApp')) {
                    <span class="editPageTab"
                      [ngClass]="{'editPageTab-active' : activeTab === 2}"
                    (click)="activeTab = 2">{{'EMA_SETTINGS' |translate}}</span>
                  }
                </li>
                <li class="list-inline-item">
                  @if (showIfFeatureEnabled('IotComms') && user.roleLevel === 200) {
                    <span class="editPageTab"
                      [ngClass]="{'editPageTab-active' : activeTab === 4}"
                    (click)="activeTab = 4">{{'IOTCOMMS_SETTINGS' |translate}}</span>
                  }
                </li>
                <li class="list-inline-item">
                  @if (user?.roleLevel >= 100) {
                    <span class="editPageTab" [ngClass]="{'editPageTab-active' : activeTab === 5}"
                    (click)="activeTab = 5">{{'EQUIPMENT_STATUS' |translate}}</span>
                  }
                </li>
              </ul>
            </div>
            @if (activeTab === 1) {
              <div>
                @if (updateSuccess) {
                  <div class="alert alert-success">
                    {{'LOCATION_UPDATE_SUCCESS' |translate}}
                  </div>
                }
                @if (updateError) {
                  <div class="alert alert-danger">
                    {{ updateErrorMessage || ('ERROR' | translate) }}
                  </div>
                }
                <!-- View location information-->
                @if (!editMode) {
                  <div>
                    <div>
                      <strong>{{'NAME' |translate}}:</strong> {{location.name}}
                    </div>
                    @if (showIfFeatureEnabled('Joliv');) {
                      <div>
                        <strong>{{'QUALIFIER' |translate}}:</strong> {{location.qualifier}}
                      </div>
                    }
                    @if (location.contactPhone) {
                      <div>
                        <strong>{{'CONTACT_PHONE' |translate}}</strong> {{location.contactPhone}}
                      </div>
                    }
                    <div>
                      <strong>{{'ADDRESS' |translate}}</strong> {{location.address}}
                    </div>
                    <div>
                      <strong>{{'POSTCODE' |translate}}</strong> {{location.postCode}}
                    </div>
                    <div>
                      <strong>{{'POSTOFFICE' |translate}}</strong> {{location.postOffice}}
                    </div>
                    @if (user.roleLevel >= 100) {
                      <div class="mt-3">
                        <button class="btn btn-outline-primary gray-bg" (click)="editMode = !editMode"><span
                        class="fa-light fa-fw fa-pen-to-square"></span> {{'MODIFY' |translate}}</button>
                      </div>
                    }
                  </div>
                }
                <!-- Edit location information -->
                @if (editMode) {
                  <div>
                    <form [formGroup]="locationEditForm" (ngSubmit)="submitLocationEdit()">
                      <div class="form-group">
                        <label><strong>{{'NAME' |translate}}</strong></label>
                        <input class="form-control" type="text" placeholder="{{'NAME' |translate}}"
                          formControlName="name">
                        </div>
                        @if (showIfFeatureEnabled('Joliv');) {
                          <div class="form-group">
                            <label><strong>{{'QUALIFIER' |translate}}</strong></label>
                            <input class="form-control" type="text" placeholder="{{'QUALIFIER' |translate}}"
                              formControlName="qualifier">
                            </div>
                          }
                          <div class="form-group">
                            <label><strong>{{'CONTACT_PHONE' |translate}}</strong></label>
                            <input class="form-control" type="text" placeholder="{{'CONTACT_PHONE' |translate}}"
                              formControlName="contactPhone">
                            </div>
                            <div class="form-group">
                              <label><strong>{{'ADDRESS' |translate}}</strong></label>
                              <input class="form-control" type="text" placeholder="{{'ADDRESS' |translate}}"
                                formControlName="address">
                              </div>
                              <div class="form-group">
                                <label><strong>{{'POSTCODE' |translate}}</strong></label>
                                <input class="form-control" type="text" placeholder="{{'POSTCODE' |translate}}"
                                  formControlName="postCode">
                                </div>
                                <div class="form-group">
                                  <label><strong>{{'POSTOFFICE' |translate}}</strong></label>
                                  <input class="form-control" type="text" placeholder="{{'POSTOFFICE' |translate}}"
                                    formControlName="postOffice">
                                  </div>
                                  <div class="form-group">
                                    <label>{{'EMA_TAG_ONLY' |translate}}</label>
                                    <section>
                                      <mat-slide-toggle formControlName="emaTagOnly">
                                      </mat-slide-toggle>
                                    </section>
                                    @if (locationEditForm.get('emaTagOnly')?.value) {
                                      <div class="alert alert-warning mt-2">
                                        <span class="fa-solid fa-triangle-exclamation mr-1"></span>
                                        <span>{{'EMA_TAG_ONLY_WARNING_TEXT' |translate}}</span>
                                      </div>
                                    }
                                  </div>
                                  <div class="form-group">
                                    <button [disabled]="(locationEditForm.invalid || locationEditForm.pristine)"
                                      type="submit" class="btn btn-outline-primary gray-bg mr-1"><span
                                    class="fa-light fa-floppy-disk"></span> {{'SAVE' |translate}}</button>
                                    <button type="reset" class="btn btn-outline-danger mr-1"
                                      (click)="resetLocationEditForm()"><span class="fa-light fa-xmark"></span>
                                    {{'CANCEL' |translate}}</button>
                                    @if (user.roleLevel === 200) {
                                      <span class="btn btn-outline-danger float-right"
                                        (click)="confirmLocationDelete()"><span class="fa-light fa-octagon-minus"></span>
                                      {{'DELETE' |translate}}</span>
                                    }
                                  </div>
                                </form>
                              </div>
                            }
                          </div>
                        }
                        <!-- Content for location access rights -->
                        @if (activeTab === 3) {
                          <div>
                            <location-access-rights [location]="location"></location-access-rights>
                          </div>
                        }
                        <!-- Content for EMA settings -->
                        @if (activeTab === 2) {
                          <div>
                            <location-ema-settings [location]="location"></location-ema-settings>
                          </div>
                        }
                        <!-- Content for IotComms settings -->
                        @if (activeTab === 4) {
                          <div>
                            <location-iotcomms-settings [location]="location"></location-iotcomms-settings>
                          </div>
                        }
                        <!-- Content for Equipment status -->
                        @if (activeTab === 5) {
                          <div>
                            <location-equipment-status [location]="location" [devices]="devices"></location-equipment-status>
                          </div>
                        }
                      </div>
                    }
                    <!--Information and confirmation for location deletion-->
                    @if (deleteConfirmation) {
                      <div class="col-lg-12">
                        <div class="card-body-container">
                          @if (deleteError) {
                            <div>
                              <div class="alert alert-danger">{{'ERROR' |translate}}</div>
                            </div>
                          }
                          <div>
                            <strong>{{'LOCATION_DELETE_CONFIRM' |translate: {location: location.name + ' - ' + location.id}
                            }}</strong>
                          </div>
                          @if (locationConfirmData?.devices.length > 0 || locationConfirmData?.personnels.length > 0 || locationConfirmData?.alarmRoutes.length > 0) {
                            <div
                              >
                              <strong>{{'LOCATION_DELETE_CONFIRM_DEVICES' |translate}}</strong>
                              @if (locationConfirmData?.devices.length > 0) {
                                <div>
                                  {{'DEVICES' |translate}}
                                  <ul>
                                    @for (dev of locationConfirmData.devices; track dev) {
                                      <li>@if (dev.name) {
                                        <span>{{dev.name}}
                                        - </span>
                                      } {{dev.id}}</li>
                                    }
                                  </ul>
                                </div>
                              }
                              @if (locationConfirmData?.personnels.length > 0) {
                                <div>
                                  {{'STAFF_MEMBERS' |translate}}
                                  <ul>
                                    @for (personnel of locationConfirmData.personnels; track personnel) {
                                      <li>@if (personnel.firstName) {
                                        <span
                                        >{{personnel.firstName}} </span>
                                        }@if (personnel.familyName) {
                                        <span
                                        >{{personnel.familyName}} -</span>
                                      }
                                    {{personnel.username}}, {{personnel.id}}</li>
                                  }
                                </ul>
                              </div>
                            }
                            @if (locationConfirmData?.alarmRoutes.length > 0) {
                              <div>
                                {{'ALARM_ROUTES' |translate}}
                                <ul>
                                  @for (route of locationConfirmData.alarmRoutes; track route) {
                                    <li>@if (route.name) {
                                      <span
                                      >{{route.name}} - </span>
                                    } {{route.id}}</li>
                                  }
                                </ul>
                              </div>
                            }
                          </div>
                        }
                        <div>
                          <button class="btn btn-outline-danger mr-1" (click)="confirmDelete()"><span
                          class="fa-light fa-octagon-minus"></span> {{'DELETE' |translate}}</button>
                          <button class="btn btn-outline-primary gray-bg" (click)="cancelDelete()"><span
                          class="fa-light fa-xmark"></span> {{'CANCEL' |translate}}</button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
